/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import DeleteModal from "../../Components/DeleteModal";
import { BASE_API_URL } from "../../API/Base";
import AxiosInstance from "../../API/axios";

import {
  AddCircleRounded,
  DashboardCustomize,
  DashboardCustomizeRounded,
  Delete,
  DeleteRounded,
  FilePresentRounded,
} from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";

import React, { ChangeEvent, useEffect, useState } from "react";
import toast from "react-hot-toast";
import EditLesson from "./EditLesson";
import { useNavigate, useParams } from "react-router-dom";
import { Category, Courses, Status_Type, SubCategory, UnifiedFormParams } from "src/types";
interface Lesson {
  // lesson_id: number;
  title: string;
  duration: string;
  video_type: string;
  video_url: string;
  lesson_type: string;
  attachment_url: string;
  attachment_type: string;
}

interface Section {
  // section_id: number;
  title: string;
  lessons: Lesson[];
}

interface FormData {
  title: string;
  short_description: string;
  outcome: string;
  requirements: string;
  price: number;
  status: boolean;
  duration: string;
  exam_type: string;
  category_id: string;
  subcategory_id: string;
  sections: Section[];
}

const initialLessonState: Lesson = {
  // lesson_id: 0,
  title: "",
  duration: "",
  video_type: "",
  video_url: "",
  lesson_type: "",
  attachment_url: "",
  attachment_type: "",
};

const initialSectionState: Section = {
  // section_id: 0,
  title: "",
  lessons: [initialLessonState],
};

const initialFormState: FormData = {
  title: "",
  short_description: "",
  outcome: "",
  requirements: "",
  price: 0,
  status: true,
  duration: "",
  exam_type: "",
  category_id: "",
  subcategory_id: "",
  sections: [initialSectionState],
};

const EditCourse = ({ data }: any) => {
  const { id } = useParams<UnifiedFormParams>();
  const [apiData, setApiData] = useState<any>([]);
  const [formData, setFormData] = useState<FormData>(initialFormState);
  const [file, setFile] = useState<File | null>(null);
  const [fetchedThumbnail, setFetchedThumbnail] = useState<string | null>("");
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const [thumbnailName, setThumbnailName] = useState<string>("");
  const [categories, setCategories] = useState<Category[]>([]);
  const [subcategories, setSubCategories] = useState<SubCategory[]>([]);
  const [examType, setExamType] = useState<Status_Type[]>([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
  const [selectedSection, setSelectedSection] = useState<Section | null>(null);
  const [sectionTitle, setSectionTitle] = useState<string>("");
  const [lesType, setLesType] = useState<Status_Type[]>([]);
  const [lessonTitle, setLessonTitle] = useState<string>("");
  const [lessonDuration, setLessonDuration] = useState<string>("");
  const [lessonVideoType, setLessonVideoType] = useState<string>("");
  const [lessonVideoUrl, setLessonVideoUrl] = useState<string>("");
  const [lessonLessonType, setLessonLessonType] = useState<string>("");
  const [lessonAttachmentUrl, setLessonAttachmentUrl] = useState<string>("");
  const [lessonAttachmentType, setLessonAttachmentType] = useState<string>("");
  const [lessonModalOpen, setLessonModalOpen] = useState<{
    open: boolean;
    section: Section | null;
  }>({
    open: false,
    section: null,
  });
  const navigate = useNavigate();

  const base64Decode = (encodedStr: string) => {
    return atob(encodedStr);
  };

  const decodedId = id ? base64Decode(id) : null;

  const fetchData = async () => {
    try {
      const response = await AxiosInstance.get(
        `${BASE_API_URL}/admin/courses/v1/get-course-with-sections-and-lessons${decodedId}`
      );

      const data: Courses = response.data;
      setApiData(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const fetchCategory = async () => {
    try {
      const response = await AxiosInstance.get(
        "/admin/courses/v1/get-category"
      );
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchSubcategory = async () => {
    try {
      const response = await AxiosInstance.get(
        "/admin/courses/v1/get-sub-category"
      );
      setSubCategories(response.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };
  const fetchExamType = async () => {
    try {
      const response = await AxiosInstance.get<Status_Type[]>(
        "/admin/courses/v1/get-exam-type"
      );
      setExamType(response.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchLessonType = async () => {
    try {
      const response = await AxiosInstance.get("/admin/courses/v1/lesson-type");
      setLesType(response.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchCourseImage = async () => {
    try {
      const response = await AxiosInstance.get(
        `/admin/courses/v1/get-image/${decodedId}`,
        {
          responseType: "blob",
        }
      );
      // Create a blob URL for the image
      const blob = new Blob([response.data]);
      const imageUrl = URL.createObjectURL(blob);

      setFetchedThumbnail(imageUrl);
    } catch (error) {
      console.error("Error fetching course image:", error);
    }
  };

  useEffect(() => {
    setFormData({
      title: data.title,
      short_description: data.short_description,
      outcome: data.outcome,
      requirements: data.requirements,
      price: data.price,
      status: data.status,
      duration: data.duration,
      exam_type: data.exam_type,
      category_id: data.category_id,
      subcategory_id: data.subcategory_id,
      sections: data.sections,
    });

    fetchCategory();
    fetchExamType();
    fetchSubcategory();
    fetchLessonType();
    fetchCourseImage();
  }, [data]);

  // Handles the change event of the file input and updates the state with the selected file.
  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const selectedFile = event.target.files[0];
      setThumbnailName(selectedFile.name);
      setFile(selectedFile);
      const previewURL = URL.createObjectURL(selectedFile);
      setImagePreview(previewURL);
    }
  };

  const handleInputChange = (key: string, value: any) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false);
  };

  const handleDeleteSection = (section: Section) => {
    setIsDeleteModalOpen(true);
    setSelectedSection(section);
  };

  const handleAddLessonModal = (section: Section) => {
    setLessonModalOpen({ open: true, section });
  };

  // Handles the addition of a new section.
  const handleAddSection = async () => {
    // if title is empty then return
    if (sectionTitle.trim() === "") {
      toast.error("Section title cannot be empty");
      return;
    }
    const newSection = {
      title: sectionTitle,
      lessons: [],
    };
    setFormData((prevState) => ({
      ...prevState,
      sections: [...prevState.sections, newSection],
    }));
    setSectionTitle("");
  };

  // Handles the addition of a new lesson to a selected section
  const handleAddLesson = async (selectedSection: Section) => {
    const newLesson = {
      title: lessonTitle.trim(),
      duration: lessonDuration.trim(),
      video_type: lessonVideoType.trim(),
      video_url: lessonVideoUrl.trim(),
      lesson_type: lessonLessonType.trim(),
      attachment_url: lessonAttachmentUrl.trim(),
      attachment_type: lessonAttachmentType.trim(),
    };
    try {
      const response = await AxiosInstance.post(
        `${BASE_API_URL}/admin/courses/v1/add-sections-and-lessons/${data.course_id}`,
        [{ title: selectedSection.title, lessons: [newLesson] }]
      );

      if (response.status === 200) {
        // If the request is successful, update the local state with the new lesson
        const updatedSections = formData.sections.map((section) => {
          if (section.title === selectedSection.title) {
            return {
              ...section,
              lessons: [...section.lessons, newLesson],
            };
          }
          return section;
        });

        // Update formData with the updated sections
        setFormData((prevFormData) => ({
          ...prevFormData,
          sections: updatedSections,
        }));

        // Close the lesson modal
        setLessonModalOpen({ open: false, section: null });
      } else {
        toast.error("Error adding lesson");
      }
    } catch (error) {
      console.error("Error adding lesson:", error);
    }
  };

  // Handles the editing of a lesson.
  const handleEditLesson = async (formData: any) => {
    try {
      const response = await AxiosInstance.put(
        `${BASE_API_URL}/admin/courses/v1/update-lesson/${formData.id}`,
        formData
      );

      if (response.status === 200) {
        window.location.reload();
        toast.success("Lesson updated successfully!");
      } else {
        toast.error("Failed to update lesson. Please try again later.");
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Deletes a section with its associated lessons from the server and updates the formData state
  const handleDeleteConfirm = async (section: any) => {
    try {
      const response = await AxiosInstance.delete(
        `${BASE_API_URL}/admin/courses/v1/delete-section-with-lessons/${section.section_id}`,
        { data: section }
      );
      if (response.status === 200) {
        const updatedSections = formData.sections.filter(
          (s) => s.title !== section.title
        );
        setFormData({ ...formData, sections: updatedSections });
        toast.success("Section deleted successfully!");
        setIsDeleteModalOpen(false);
      }
    } catch (error) {
      console.error("Error deleting section:", error);
    }
  };

  // Deletes a lesson from the formData sections and updates the formData state.
  const handleDeleteLesson = async (lesson: any) => {
    try {
      const response = await AxiosInstance.delete(
        `/admin/courses/v1/delete-lesson/${lesson.lesson_id}`
      );

      if (response.status === 200) {
        // Filter out the deleted lesson from the lessons array using the lesson ID
        const updatedSections = formData.sections.map((section) => ({
          ...section,
          lessons: section.lessons.filter((l) => l.title !== lesson.title),
        }));

        // Update formData with the updated sections
        setFormData((prevFormData) => ({
          ...prevFormData,
          sections: updatedSections,
        }));

        toast.success("Lesson deleted successfully");
      }
    } catch (error) {
      console.error("Error deleting lesson:", error);
    }
  };

  //  Handles the form submission.
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const response = await AxiosInstance.put(
        `${BASE_API_URL}/admin/courses/v1/update-course/${data.course_id}`,
        formData
      );

      if (response.status === 200) {
        toast.success("Course updated successfully!");
        await handleUploadThumbnail();
        // refresh the page
        // window.location.reload();
      } else {
        toast.error("Failed to update course. Please try again later.");
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Handles the upload of a thumbnail image.
  const handleUploadThumbnail = async () => {
    try {
      if (file) {
        // Check if file is not null
        const formData = new FormData();
        formData.append("file", file);

        const response = await AxiosInstance.put(
          `${BASE_API_URL}/admin/courses/v1/update-media/${decodedId}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.status === 200) {
          // Thumbnail uploaded successfully
          toast.success("Course created successfully");
        } else {
          // Handle other status codes or errors
          console.error("Error uploading thumbnail:", response.data.message);
        }
      } else {
        console.error("File is null. Cannot upload thumbnail.");
      }
    } catch (error) {
      // Handle any network or other errors
      console.error("Error uploading thumbnail:", error);
    }
  };

  return (
    <div className="flex flex-col items-start justify-start w-full h-full max-w-6xl mx-auto mt-4">
      <div className="flex flex-col w-full mb-4">
        <div className="flex flex-row items-center p-2 mt-6 rounded-md bg-primary_shade">
          <DashboardCustomize className="mr-2 text-3xl text-blue" />
          <p className="text-xl font-semibold leading-3 tracking-normal text-blue">
            Edit course banner
          </p>
        </div>
        <div className="flex flex-col items-center mt-8 justify-center border border-blue/25 rounded-md border-dashed px-4 py-4 container w-[90%] mx-auto">
          {fetchedThumbnail && !file && (
            <div className="w-full">
              <div className="flex items-center justify-between w-full p-4 mb-6 rounded-md shadow-sm bg-primary_shade">
                <div className="flex items-center flex-start">
                  <FilePresentRounded className="mr-2 text-blue" />
                  <h3 className="text-base font-semibold text-blue">
                    Course banner
                  </h3>
                </div>
                <div>
                  <DeleteRounded
                    className="ml-4 cursor-pointer text-blue"
                    onClick={() => setFetchedThumbnail(null)}
                  />
                </div>
              </div>
              {fetchedThumbnail && (
                <img
                  src={fetchedThumbnail}
                  alt="Uploaded thumbnail"
                  className="object-contain w-full mb-2 rounded-md h-96"
                />
              )}
            </div>
          )}

          {!fetchedThumbnail && !file && (
            <div className="flex flex-col items-center justify-center">
              <label
                htmlFor="file-upload"
                className="flex items-center justify-center"
              >
                <AddCircleRounded
                  sx={{ fontSize: "2rem" }}
                  className="mr-2 cursor-pointer text-blue"
                />
                <input
                  id="file-upload"
                  type="file"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                />
                <h3 className="text-base text-zinc-500">
                  Choose file to upload
                </h3>
              </label>
            </div>
          )}

          {file && (
            <div className="w-full">
              <div className="flex items-center justify-between w-full p-4 mb-6 rounded-md shadow-sm bg-primary_shade">
                <div className="flex items-center flex-start">
                  <FilePresentRounded className="mr-2 text-blue" />
                  <h3 className="text-base font-semibold text-blue">
                    {thumbnailName}
                  </h3>
                </div>
                <div>
                  <DeleteRounded
                    className="ml-4 cursor-pointer text-blue"
                    onClick={() => setFile(null)}
                  />
                </div>
              </div>
              {imagePreview && (
                <img
                  src={imagePreview}
                  alt="Uploaded thumbnail"
                  className="object-contain w-full mb-2 rounded-md h-96"
                />
              )}
            </div>
          )}
        </div>
      </div>

      <div className="flex flex-row items-center w-full p-2 mt-6 mb-4 rounded-md bg-primary_shade">
        <DashboardCustomizeRounded className="mr-2 text-3xl text-blue" />
        <p className="text-xl font-semibold leading-3 tracking-normal text-blue">
          Edit course information
        </p>
      </div>

      <form>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              label="Title"
              name="title"
              fullWidth
              margin="dense"
              size="small"
              value={formData.title || ""}
              onChange={(e) => handleInputChange("title", e.target.value)}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Short Description"
              fullWidth
              margin="dense"
              size="small"
              name="short_description"
              value={formData.short_description}
              onChange={(e) =>
                handleInputChange("short_description", e.target.value)
              }
              className="w-full p-2 mt-1 border border-gray-300 rounded-md"
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Outcome"
              fullWidth
              margin="dense"
              size="small"
              name="outcome"
              value={formData.outcome}
              onChange={(e) => handleInputChange("outcome", e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Requirements"
              fullWidth
              margin="dense"
              size="small"
              name="requirements"
              value={formData.requirements}
              onChange={(e) =>
                handleInputChange("requirements", e.target.value)
              }
              className="w-full p-2 mt-1 border border-gray-300 rounded-md"
            />
          </Grid>
          <Grid item xs={6}>
            <FormControl
              fullWidth
              variant="outlined"
              margin="dense"
              size="small"
            >
              <InputLabel>Category</InputLabel>
              <Select
                value={formData.category_id || ""}
                label="Category"
                name="category_id"
                onChange={(e) =>
                  handleInputChange("category_id", e.target.value)
                }
              >
                {categories.map((category) => (
                  <MenuItem value={category.Category_Id}>
                    {category.Category_Name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6}>
            <FormControl
              fullWidth
              variant="outlined"
              margin="dense"
              size="small"
            >
              <InputLabel>Sub Category</InputLabel>
              <Select
                value={formData.subcategory_id || ""}
                label="SubCategory"
                name="subcategory_id"
                onChange={(e) =>
                  handleInputChange("subcategory_id", e.target.value)
                }
              >
                {subcategories.map((sub) => (
                  <MenuItem
                    key={sub.Sub_Category_Name}
                    value={sub.Sub_Category_Name}
                  >
                    {sub.Sub_Category_Name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="Price"
              fullWidth
              margin="dense"
              size="small"
              type="number"
              name="price"
              value={formData.price}
              onChange={(e) => handleInputChange("price", e.target.value)}
              className="w-full p-2 mt-1 border border-gray-300 rounded-md"
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="Duration"
              fullWidth
              margin="dense"
              size="small"
              type="text"
              name="duration"
              value={formData.duration}
              onChange={(e) => handleInputChange("price", e.target.value)}
              className="w-full p-2 mt-1 border border-gray-300 rounded-md"
            />
          </Grid>

          <Grid item xs={6}>
            <FormControl
              fullWidth
              variant="outlined"
              margin="dense"
              size="small"
            >
              <InputLabel>Exam type</InputLabel>
              <Select
                value={formData.exam_type || ""}
                label="Exam type"
                name="exam_type"
                onChange={(e) => handleInputChange("exam_type", e.target.value)}
              >
                {examType.map((type) => (
                  <MenuItem key={type.Status_Name} value={type.Status_Name}>
                    {type.Status_Name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <div className="flex flex-row items-center justify-between w-full p-2 mt-6 mb-4 rounded-md bg-primary_shade">
          <div className="flex items-center mr-4">
            <DashboardCustomizeRounded className="mr-2 text-3xl text-blue " />
            <p className="text-xl font-semibold leading-3 tracking-normal text-blue">
              Edit sections and lessons
            </p>
          </div>
        </div>

        <div className="w-full max-w-md mx-auto mt-8">
          <div className="relative ">
            <input
              type="text"
              className="block w-full p-4 text-gray-900 rounded-lg ps-10 bg-zinc-100 focus:outline-none focus:ring-primary"
              placeholder="Add new section"
              required
              value={sectionTitle || ""}
              onChange={(e) => setSectionTitle(e.target.value)}
            />
            <button
              type="button"
              onClick={handleAddSection}
              className="text-white absolute end-2.5 bottom-2.5 bg-primary hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 "
            >
              Add new section
            </button>
          </div>
        </div>

        {formData.sections && formData.sections.length > 0 && (
          <div className="container w-full mx-auto mt-10">
            <Grid container spacing={10}>
              {formData.sections.map((section, sectionIndex) => (
                <Grid item xs={6} key={sectionIndex}>
                  <Card>
                    <CardContent
                      sx={{
                        borderTop: "3px solid #00A99D",
                        borderRadius: "5px",
                      }}
                    >
                      <div className="flex flex-row items-center justify-between w-full">
                        <h2 className="text-lg font-semibold text-black md:text-xl lowrrcase">
                          Section {sectionIndex + 1} : {section.title}
                        </h2>

                        <Delete
                          onClick={() => handleDeleteSection(section)}
                          className="cursor-pointer text-Delete"
                          sx={{ fontSize: "20px", marginRight: "5px" }}
                        />
                      </div>

                      {section.lessons.length > 0 && (
                        <ul>
                          {section.lessons.map((lesson, lessonIndex) => (
                            <EditLesson
                              key={lesson.title}
                              lesson={lesson}
                              handleDeleteLesson={() =>
                                handleDeleteLesson(lesson)
                              }
                              handleEditLesson={handleEditLesson}
                              data={formData}
                            />
                          ))}
                        </ul>
                      )}

                      <Box>
                        <Button
                          style={{
                            border: "1px dotted #00A99D",
                            color: "#00A99D",
                            padding: "0px 3px",
                            marginTop: "12px",
                            textTransform: "none",
                            fontSize: "12px",
                          }}
                          onClick={() => handleAddLessonModal(section)}
                        >
                          Add lesson
                        </Button>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </div>
        )}
      </form>

      {/* Add Lesson Modal starts here */}
      <Dialog
        open={lessonModalOpen.open}
        onClose={() => setLessonModalOpen({ open: false, section: null })}
      >
        <div className="fixed w-full max-w-screen-md p-4 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg shadow-lg top-1/2 left-1/2 md:w-1/2 md:p-8">
          <h2 className="px-4 py-2 text-lg font-semibold md:text-xl bg-primary_shade text-blue">
            Add new lesson
          </h2>
          <div className="w-full mt-4">
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  label="Lesson Title"
                  value={lessonTitle}
                  onChange={(e) => setLessonTitle(e.target.value)}
                  fullWidth
                  margin="dense"
                  size="small"
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Duration"
                  value={lessonDuration}
                  onChange={(e) => setLessonDuration(e.target.value)}
                  fullWidth
                  margin="dense"
                  size="small"
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Video Type"
                  value={lessonVideoType}
                  onChange={(e) => setLessonVideoType(e.target.value)}
                  fullWidth
                  margin="dense"
                  size="small"
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Video URL"
                  value={lessonVideoUrl}
                  onChange={(e) => setLessonVideoUrl(e.target.value)}
                  fullWidth
                  margin="dense"
                  size="small"
                />
              </Grid>

              <Grid item xs={6}>
                <FormControl
                  fullWidth
                  variant="outlined"
                  margin="dense"
                  size="small"
                >
                  <InputLabel>Lesson type</InputLabel>
                  <Select
                    value={lessonLessonType}
                    label="Lesson type"
                    onChange={(e) =>
                      setLessonLessonType(e.target.value as string)
                    }
                  >
                    {lesType.map((type) => (
                      <MenuItem value={type.Status_Name}>
                        {type.Status_Name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Attachment URL"
                  value={lessonAttachmentUrl}
                  onChange={(e) => setLessonAttachmentUrl(e.target.value)}
                  fullWidth
                  margin="dense"
                  size="small"
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Attachment Type"
                  value={lessonAttachmentType}
                  onChange={(e) => setLessonAttachmentType(e.target.value)}
                  fullWidth
                  margin="dense"
                  size="small"
                />
              </Grid>
            </Grid>
          </div>

          <div className="flex items-center justify-between w-full mt-10">
            <button
              type="button"
              className="px-4 py-2 border rounded-md border-primary text-primary"
              onClick={() => setLessonModalOpen({ open: false, section: null })}
            >
              Cancel
            </button>
            <button
              type="button"
              className="px-4 py-2 text-white rounded-md bg-primary"
              onClick={() =>
                lessonModalOpen.section &&
                handleAddLesson(lessonModalOpen.section)
              }
            >
              Save changes
            </button>
          </div>
        </div>
      </Dialog>
      {/* Add Lesson Modal ends here*/}

      <div className="flex items-center justify-between w-full mt-10">
        <button
          type="submit"
          className="px-4 py-2 border rounded-md border-primary text-primary"
          onClick={() => navigate("/courses/manage")}
        >
          Back
        </button>
        <button
          type="submit"
          className="px-4 py-2 text-white rounded-md bg-primary"
          onClick={handleSubmit}
        >
          Save changes
        </button>
      </div>
      <DeleteModal
        isOpen={isDeleteModalOpen}
        onClose={handleDeleteCancel}
        onConfirm={handleDeleteConfirm}
        title="Confirm Deletion"
        message="Are you sure you want to delete this data?"
        section={selectedSection}
      />
    </div>
  );
};

export default EditCourse;
